export default __webpack_public_path__ + "static/SRF 4400 - Product Specifications & Technical Data-d8956c57ae94e1fe850576db95757942.pdf";